import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBoltIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 8,
	height: 10.198,
	viewBox: "0 0 8 10.198",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		"data-name": "Icon - Bolt",
		d: "M5,1V4.5H8L4,10V6.5H1L5,1",
		transform: "translate(-0.5 -0.302)",
		fill: "none",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1
	})
});
export { SvgBoltIcon as ReactComponent };
